import React, { useState } from "react";

import "./DescriptionInput.scss";

interface IDescriptionInput {
  descriptionValue?: string | null;
  setDescriptionValue?: React.Dispatch<React.SetStateAction<string | null>>;
}

const DescriptionInput = ({
  descriptionValue,
  setDescriptionValue,
}: IDescriptionInput) => {
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDescriptionValue && setDescriptionValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (descriptionValue && descriptionValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={descriptionValue || ""}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">Description</span>
        </label>
      </div>
    </div>
  );
};

export { DescriptionInput };
